import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { MarkdownPreview } from "components/common/MarkdownEditor";
const StyledCode = styled.code`
  background-color: transparent;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: ${({ $disabled }) => $disabled ? "default" : "pointer"};
  width: auto;

  &:hover {
    color: ${({ theme, $disabled }) => $disabled ? theme.colors.text.secondary : theme.colors.text.primary};
  }
`;
const MarkdownWrapper = styled.div`
  cursor: pointer;
`;
function DescriptionCell({ mdValue, noExpand = false }) {
  const { t } = useTranslation("enterprise_security_events");
  const [showFormatted, setShowFormatted] = useState(false);
  const stringMaxLength = 100;
  if (!mdValue)
    return /* @__PURE__ */ React.createElement(StyledCode, { $disabled: true }, /* @__PURE__ */ React.createElement("i", null, t("description_cell.no_description")));
  const onClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShowFormatted((prev) => !prev);
  };
  return showFormatted ? /* @__PURE__ */ React.createElement(MarkdownWrapper, { onClick }, /* @__PURE__ */ React.createElement(MarkdownPreview, { show: true, maxHeight: 500, noBackground: true, noBorder: true, value: mdValue, noPadding: true })) : /* @__PURE__ */ React.createElement(StyledCode, { onClick: noExpand ? () => {
  } : onClick, $disabled: noExpand }, `${mdValue.slice(0, stringMaxLength)}${mdValue.length >= stringMaxLength ? "..." : ""}`);
}
export default DescriptionCell;
